var SiteSearch = { 

    itemsPerPageitemsPerPage: 12,
    SearchType: "",
    initialSearch: true,
    searchParams: null,
    renderPartial: null,
    me: this,

    // Init - Called from the script Utils.AddScript() tag in the template
    InitSiteSearch : function (hasSearchTerm, _itemsPerPage, _renderPartial) {
        this.SearchType = "SiteSearch";

        if (isEmptyOrSpaces(_renderPartial)) {
            alert('Need to pass in the partial name that will render the result');
            return;
        }
        this.renderPartial = _renderPartial;

        if (_itemsPerPage !== undefined && _itemsPerPage !== null && parseInt(_itemsPerPage) > 0) {
            this.itemsPerPage = parseInt(_itemsPerPage);
        }

        if (hasSearchTerm === true) {
            this.initialSearch = false;  // Prevent a keyword from the query string from being overwritten
        }

        var prom = this.GetSearchResults(1);
        prom.then(
            function (result) {
                console.log("Search results : %o", result);

                $('#search__results').html(result.htmlResults);

                $('#pagination_search').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.itemsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        this.DoAjaxSearch(pageNumber);
                        scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                    }.bind(this),
                    onInit: function () {
                        console.log('Init paging');
                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }
                        this.DoPagination(resultCount, 1);
                    }.bind(this)
                });
            }.bind(this)
        );

        $('#siteSearchButtonSearch').click(function (event) {
            event.preventDefault();
            console.log('Search box icon clicked');
            var query = $('#searchboxSite').val();
            this.UpdateParams(query);
            this.DoAjaxSearch(1);
        }.bind(this));

        $('#siteSearchButtonClear').click(function (event) {
            event.preventDefault();
            this.ClearSiteSearch();
        }.bind(this));

        $('#searchboxSite').keypress(function (event) {
            console.log('Key press : %o', event.keyCode);
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode === '13') {
                this.DoAjaxSearch(1);
            }
        }.bind(this));

        // Add events for checkboxes
        $(".search__aggregation input[type='checkbox']").click(function () {
            this.DoAjaxSearch(1);
        }.bind(this));

        document.getElementById("searchboxSite").addEventListener("search", function (event) {
            console.log('SEARCH EVENT');
            this.DoAjaxSearch(1);
        }.bind(this));

        // filter expand
        var filterTrigger = $('.search__filter-button');
        var filters = $('.search__filters');
    
        filterTrigger.click(function() {
            if (filters.is(':visible')) {
                filters.slideUp(); 
            } else {
                filters.css('display', 'flex').hide().slideDown(); 
            }
        });
    },

    ClearSiteSearch : function () {
        // Uncheck all the boxes
        $('.search__aggregation input[type=checkbox]').removeAttr('checked');
        $('.search__aggregation .search__aggregation-icon').removeClass('search__aggregation-icon--active');
        this.DoAjaxSearch(1);
    },

    DoPagination : function (resultCount, currentPage) {
        var $pagination = $('#pagination_search');

        console.log('Page results count : %o - Per page : %o', resultCount, this.itemsPerPage);

        if (resultCount !== null && resultCount > this.itemsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },

    DoAjaxSearch : function (pageNo) {
        var prom = this.GetSearchResults(pageNo);
        prom.then(
            function (result) {
                console.log("Processing ajax results : %o", result);

                $('#search__results').html(result.htmlResults);

                this.DoPagination(result.totalResultCount, pageNo);

                scrollToAnchorIDOffset('topOfSearch');
            }.bind(this)
        );
    },

    // Do our ajax call to fetch the results
    GetSearchResults : function (pageNo, rootNode) {
        return new Promise(function (resolve, reject) {
            var paramSource = "";
            paramSource = "fields";
            searchParams = this.BuildSiteSearchParams(pageNo);

            console.log('GetSearchResults with %o searchParams : %o', paramSource, searchParams);
            this.initialSearch = false;

            fetch('/umbraco/surface/siteSearch/DoSiteSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
            .then(function (response) {
                resolve(response.json());
            })
            .catch(error => {
                console.log('Failed', error);
                reject(error);
            });
        }.bind(this));
    },

    BuildSiteSearchParams : function (pageNo) {
        searchParams = {};
        searchParams.currentResultPage = pageNo;
        searchParams.partialView = this.renderPartial;

        // Query
        if ($('#searchboxSite').val() !== '') {
            searchParams.keywords = $('#searchboxSite').val();
        }

        searchParams.resultsPerPage = this.itemsPerPage;
        return searchParams;
    },

    UpdateParams : function (searchBox)
    {
        console.log('UpdateParams : %o', searchBox);
        var url = new URL(window.location);
        url.searchParams.set("query", searchBox);
        history.pushState(null, '', url);
    }
}